import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import Loading from './Loading.vue'
import modalHelper from '@ms/utils/scroll-fixed'

const LoadingConstructor = Vue.extend(Loading)

const toggleLoading = (el, binding) => {
  if (binding.value) {
    Vue.nextTick(() => {
      if (binding.modifiers.fullscreen) {
        // const bodyStyle = window.getComputedStyle(document.body)
        // el.originalPosition = bodyStyle.position
        // el.originalOverflow = bodyStyle.overflow
        insertDom(document.body, el, binding)
      } else {
        const elStyle = window.getComputedStyle(el)
        el.originalPosition = elStyle.position
        insertDom(el, el, binding)
      }
    })
  } else {
    if (binding.modifiers.fullscreen && !binding.modifiers.fixed) {
      modalHelper.beforeClose()
    }
    if (el.domVisible) {
      el.instance.$on('after-leave', () => {
        el.domVisible = false
        if (binding.modifiers.fullscreen) {
          // modalHelper.beforeClose()
          // document.body.style.position = el.originalPosition
          // if (el.originalOverflow !== 'hidden') {
          //   document.body.style.overflow = el.originalOverflow
          // }
        } else {
          el.style.position = el.originalPosition
        }
      })
      el.instance.visible = false
    } else {
      el.instance.visible = false
    }
  }
}

const insertDom = (parent, el, binding) => {
  if (!el.domVisible) {
    if (!binding.modifiers.fullscreen) {
      Object.keys(el.loadingStyle).forEach((property) => {
        el.loading.style[property] = el.loadingStyle[property]
      })

      if (el.originalPosition !== 'absolute') {
        parent.style.position = 'relative'
      }
    } else {
      el.loading.style.height = window.innerHeight + 'px'
      el.loading.style.top = 'auto'
    }

    el.domVisible = true
    parent.appendChild(el.loading)
    Vue.nextTick(() => {
      el.instance.visible = true
      if (binding.modifiers.fullscreen) {
        // parent.style.overflow = 'hidden'
        modalHelper.afterOpen()
      }
    })
    el.domInserted = true
  }
}

Vue.directive('loading', {
  bind: (el, binding) => {
    const { fullscreen, light, fixed } = binding.modifiers
    const loading = new LoadingConstructor({
      i18n,
      el: document.createElement('div'),
      data: {
        text: el.getAttribute('loading-text') || 'loading',
        fullscreen: !!fullscreen,
        light: !!light,
        fixed: !!fixed
      }
    })
    el.instance = loading
    el.loading = loading.$el
    el.loadingStyle = {}
    toggleLoading(el, binding)
  },
  update: (el, binding) => {
    const loadingText = el.getAttribute('loading-text') || 'loading'
    el.instance.setText(loadingText)
    if (binding.oldValue !== binding.value) {
      toggleLoading(el, binding)
    }
  },
  unbind: (el, binding) => {
    // modalHelper.beforeClose()
    if (el.instance) {
      el.instance.$destroy()
      el.instance = null
    }

    if (el.domInserted) {
      if (binding.modifiers.fullscreen) {
        document.body.removeChild(el.loading)
      } else {
        el.loading && el.loading.parentNode && el.loading.parentNode.removeChild(el.loading)
      }
      el.loading = null
    }
  }
})
